import React from 'react'
import { TextField } from '@mui/material';

export default function Input(props) {
    const { name, label, sx, value="", error = null, onChange, disabled, ...rest } = props;
    return (
        <TextField
            variant='outlined'
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            {...rest}
            fullWidth
            {...(error && { error: true, helperText: error })}
        />
    )
}
